module.exports = __webpack_public_path__ + "static/media/pic00.7a7dadd2.svg";